module.exports = "<template>\n    <div>\n        <vbl-tab-group :selected-index.sync=\"index\">\n            <vbl-tab label=\"标题1\">内容1</vbl-tab>\n            <vbl-tab label=\"标题2\">内容2</vbl-tab>\n            <vbl-tab label=\"标题3\">内容3</vbl-tab>\n        </vbl-tab-group>\n    </div>\n</template>\n\n<script>\nexport default {\n    data() {\n        return {\n            index: 0\n        }\n    }\n};\n</script>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/vblTab/example/vblTabExample.vue
// module id = 177
// module chunks = 0